import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Spinner,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  TabPane,
  TabContent,
  Nav,
  CardHeader,
  NavItem,
  NavLink
} from 'reactstrap';
import ApproveInvitation from './components/forms/ApproveInvitation';
import no_vouchers from '../../../../../assets/no_vouchers.png';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID, getUserID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_List, gAPI_Internal_Property_By_Id,
  gAPI_Users_By_Id, gAPI_Vouchers_By_Id, gAPI_MembershipTags,
  gAPI_Invitation_By_Email, postAPI_TrackEvent,
  putAPI_approve_voucher, gAPI_Orders_Voucher,
  API_Ingetration, gAPI_Property_List, putAPI_Vouchers_Order
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ShowInvitations from './components/forms/ShowInvitations';
import BuyOptionList from './components/BuyOptionList';
import AcceptInvitation from './components/forms/AcceptInvitation';
import moment from 'moment';
import CreateVoucherForm from './components/forms/CreateVouchersForm';
import Pagination from '../../../../../containers/pages/Pagination';
import VoucherListItem from './components/VoucherListItem';
import PurchasedVoucher from './components/PurchasedVouchers';
import ViewOrders from '../orders/Components/ViewOrders';
import PreviewVoucherList from './components/forms/PreviewVoucherList';
import ReactDragListView from "react-drag-listview";
import CodeList from './components/CodeList';
import { List, Typography } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';
import PromoCodes from './components/forms/PromoCodes';
import Gallery from '../../propinfo/gallery';
import Invitations from '../invitations';
import IconGallery from '../../propinfo/iconGallery';
import Validation from '../../../../../components/Validation';
function Index({ propertyId, locale, currency }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [voucherList, setVoucherList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('vouchers');

  const [search, setSearch] = useState('');
  const [showInvitations, setShowInvitations] = useState(false);
  const [pageSizes, setpageSizes] = useState([10, 15, 20, 25, 50]);
  const [currentPage, setcurrentPage] = useState(1);
  const [SelectedPageSize, setSelectedPageSize] = useState(50);
  const [visible, setVisible] = useState(false);
  const [voucherId, setVoucherId] = useState("");
  const [ispurchaseVoucherVisible, setIsPrchaseVoucherVisible] = useState(false);
  const [propertydata, setPropertyData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [voucherFilter, setVoucherFilter] = useState('');
  const [showRedeem, setShowRedeem] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [orderList, setOrderList] = useState([]);
  const [showCreateVoucherButton, setShowCreateVoucherButton] = useState(true);
  const [showVoucherList, setShowVoucherList] = useState(true);
  const [dropDown, setDropDown] = useState("");
  const [orderListByNumber, setOrderListByNumber] = useState([]);
  const [orderdataById, setOrderDataById] = useState([]);
  const [showOrderData, setShowOrderData] = useState(false);
  const [inviteVoucher, setinviteVoucher] = useState(false);
  const [buyOptionLoading, setbuyOptionLoading] = useState(true);
  const [xolaIntegration, setXolaIntegration] = useState();
  const [mewsIntegration, setMewsIntegration] = useState();
  const [reportingTagData, setReportingTagData] = useState([]);
  const [SelectedStatus, setSelectedStatus] = useState({
    column: 'All',
    label: 'All',
  });
  const [TotalItems, setTotalItems] = useState(0);
  const [TotalPages, setTotalPages] = useState(1);
  const statusOptions = [
    { column: 'All', label: 'All' },
    { column: 'Active', label: 'Active' },
    { column: 'ActiveMembers', label: 'Active - Members Only' },
    { column: 'Draft', label: 'Draft' },
    { column: 'Inactive', label: 'Inactive' },
    { column: 'Archived', label: 'Archived' },
  ];
  const [propertyVouchers, setPropertyVouchers] = useState([]);
  const [buyOption, setBuyOption] = useState([]);
  const [isBuyOption, setisBuyOption] = useState(false);
  const [showInvitation, SetShowinvitation] = useState(true);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [voucherName, setVoucheName] = useState('');
  const [websiteIntregation, setWebsiteIntregation] = useState([]);
  const [websiteIntregationId, setWebsiteIntregationId] = useState('');
  const [isHostedPageIntegration, setisHostedPageIntegration] = useState(false);
  const [amadeus, setAmadeus] = useState();
  const [memberShipTags, setMembershipTags] = useState([]);
  const [invitation, setInvitation] = useState({
    'propertyName': 'Abc',
    'propertyId': '',
    'groupId': '',
    'sellFutureVouchers': 'false',
    'invitationId': '',
    'processingFee': 7,
  });
  const [showConnectedVoucher, setShowConnectedVoucher] = useState({
    'groups': [],
    'property': [],
    'id': [],
    'senderGroupId': '',
    'senderPropertyId': '',
    'isShow': false,
    'invitationtype': ''
  });
  const [showListType, setShowListType] = useState('');
 
  const ShowInviteVoucher = (type) => {
    setinviteVoucher(type);
  };
  const handlePreviewVoucher = (val) => {
    //  setPreviewVoucher(val);
    setShowPreviewModal(val);
  }
  const handleDropDown = (name) => {
    setDropDown(name);
  }
  
  const handleVoucherFilter = (name) => {
    setVoucherFilter(name);
  }

  const handleCreateVoucherButtonShow = () => {
    setShowCreateVoucherButton(!showCreateVoucherButton);
  };

  useEffect(() => {
    localStorage.removeItem('Invitation');

    AxiosAPI({
      method: 'post',
      url: `${postAPI_TrackEvent}`,
      data: {
        eventName: 'aiva Vouchers',
        email: userData.email,
      },
    }).then(
      (res) => { },
      (error) => {
        console.log(error);
      }
    );
    extractData();
    return () => {
      try {
        if (document.getElementById('voucherbotiframe') !== undefined && document.getElementById('voucherbotiframe') !== null)
          document.getElementById('voucherbotiframe').remove();


        if (document.getElementById('bmb_webview') !== undefined && document.getElementById('bmb_webview') !== null)
          document.getElementById('bmb_webview').remove();


        if (document.getElementById('bmb_voucher_nudges_container') !== undefined && document.getElementById('bmb_voucher_nudges_container') !== null)
          document.getElementById('bmb_voucher_nudges_container').remove();
      } catch {

      }
    };
  }, [propertyId, search, currentPage, SelectedPageSize, SelectedStatus]);

  const loadTags = () => {
    let body = {
      channels: ['VoucherHostedPage', 'VoucherStandAlonePage', 'Xola', 'Mews', 'Amadues']
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
      const webIntegrationData = res.data.filter(
        (k) => (k.channel === 'VoucherHostedPage' || k.channel === 'VoucherStandAlonePage')
          && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );
      const xolaIntegrationData = res.data.filter(
        (k) => k.channel === 'Xola' && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );
      const mewsIntegrationData = res.data.filter(
        (k) => k.channel === 'Mews' && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );

      const integratioData = res.data.filter(
        (k) => k.channel === 'VoucherWebsite' && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );
      AxiosAPI({
        method: 'get',
        url: `${gAPI_MembershipTags}?propertyId=${propertyId}`,
      })
        .then((res) => {
          let tempTags = [];
          if (res.data !== undefined && res.data.tags !== undefined)
            tempTags = (res.data.tags);

          if (integratioData.length > 0) {
            integratioData.map((m) => {
              if (m.membershipTags.length > 0) {
                m.memberShipTags.map((t) => {
                  if (tempTags.filter(f => f === t).length > 0)
                    tempTags.push(t);
                });
              }
            });

          }
          setMembershipTags(tempTags);
        });



      if (mewsIntegrationData.length > 0)
        setMewsIntegration(mewsIntegrationData[0]);

      if (xolaIntegrationData.length > 0)
        setXolaIntegration(xolaIntegrationData[0]);

      const voucherHostedPageIntegration = res.data.filter(
        (k) => (k.channel === 'VoucherHostedPage' || k.channel === 'VoucherStandAlonePage') && k.disabled === false && k.properties !== undefined && k.properties.includes(propertyId)
      );
      if (voucherHostedPageIntegration.length > 0)
        setisHostedPageIntegration(true);

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
      }).then((result) => {

        const amadeusIntegration = res.data.filter(
          (k) => k.channel === "Amadues" && k.disabled === false &&
            result.data.filter((a) => k.properties.includes(a.id) && a.isAiva === true).length > 0
        );
        if (amadeusIntegration.length > 0)
          setAmadeus(amadeusIntegration[0]);
        setWebsiteIntregation(webIntegrationData);
        if (webIntegrationData.length === 1)
          setWebsiteIntregationId(webIntegrationData[0].id);


      });
    });
  }
  const extractData = async () => {
    loadTags();
    setBuyOption([]);
    setVoucherList([]);
    setLoading(true);
    await AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        setUserData(res.data);
        LoadInvitation(getUserID());
        LoadData(getGroupID(), propertyId, res.data.email);
      });
    await AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      });
  };

  const LoadInvitation = (email) => {
    let invitation_id = localStorage.getItem("Invitation");
    AxiosAPI({
      url: `${gAPI_Invitation_By_Email}?id=${email}&group_id=${getGroupID()}&property_id=${propertyId}`,
      mehthod: 'get',
    }).then((res) => {
      localStorage.setItem("invitation_data", res.data);
      if (invitation_id !== '') {
        res.data.map((m) => {
          if (m.invitationId === invitation_id) {
            handleConnectedVoucher(m.invitationId, m.groups, m.propertys, m.groupId, m.propertyId, m.type);

          }
        });
      }

      setInvitation(res.data);

    })
      .catch((err) => null);

  };
  const LoadData = (gid, pid, email) => {
    setLoading(true);
    setbuyOptionLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_List}?groupId=${gid === undefined ? getGroupID() : gid}&propertyId=${pid === undefined ? propertyId : pid}&languageCode=${locale}&search=${search}&status=${SelectedStatus.column
        }&pageNumber=${currentPage}&pageSize=${SelectedPageSize}&email=${email !== undefined ? email : userData.email}`,
    })
      .then((res) => {
        setShowListType('voucherList');
        setVoucherList(res.data.vouchers);
        setLoading(false);
        setShowCreateVoucherButton(true);
        setTotalItems(res.data.totalItems);
        setTotalPages(res.data.totalPages);
        let tags = reportingTagData;
        let ownVouchers = [];
        res.data.vouchers.map((m) => {
          if (m.status == 'Active' && m.thirdPartyVoucher == false) {
            ownVouchers.push({
              label: m.name,
              value: m.id,
              key: m.id,
            });
          }
        });
        setPropertyVouchers(ownVouchers);
        res.data.vouchers.map((m) => {

          if (m.reportingTags.length > 0)
            m.reportingTags.map((n) => {
              if (tags.filter((f) => f === n).length === 0)
                tags.push(n);
            })
        });

        setReportingTagData(tags);
        if (showListType === 'optionsList') {
          let values = [];
          res.data.vouchers.map((m) => {
            if (m.id === voucherId && m.thirdPartyVoucher === false) {
              m.buyOptions.map((item) => {
                values.push(item);
              })
            }
          });
          setbuyOptionLoading(false);
          setBuyOption(values);
        }
      })
      .catch((err) => null);
  };


  const handleBackClick = () => {
    setShowListType('voucherList');
    extractData();
  }

  const handleVoucherName = (name, id) => {
    setVoucheName(name);
    setVoucherId(id);
  };
  const handleBuyOptionSetings = (value, Id, name) => {
    setbuyOptionLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_By_Id}/${Id}`,
    }).then((res) => {
      setbuyOptionLoading(false);
      setShowListType('optionsList');
      setVoucheName(name);
      setBuyOption(res.data.sellingOptions);
      setVoucherId(Id);
      setLoading(false);
    });

  }

  const changePageSize = (size) => {
    setSelectedPageSize(size);
    setcurrentPage(1);
  };

  const onChangePage = (page) => {
    setcurrentPage(page);
  };

  const changeStatus = (column) => {
    setSelectedStatus(statusOptions.find((x) => x.column === column));
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };
  const toggleModal = () => {
    setVisible(!visible);
  };
  const startIndex = (currentPage - 1) * SelectedPageSize;
  const endIndex = currentPage * SelectedPageSize;
  const onOrdersVoucher = () => {
    setShowListType('orderVouchers');
    setShowVoucherList(false);
    setLoading(false);
  };

  const handleOrdersVoucherSubmit = () => {
    onOrdersVoucher();
    BindOrders(startDate, endDate, showRedeem, voucherId);
  };
  const handleVoucherPaymentsById = (voucherId, redeem) => {
    let item = voucherList.map((f) => { if (f.id === voucherId) { return (f.name); } });
    onOrdersVoucher();
    setVoucherId(voucherId);
    setDropDown(item);
    setShowCreateVoucherButton(false);
    if (redeem !== undefined && redeem !== 'All') {
      setShowRedeem(redeem);
    }
    let temp = [];
    // LoadSearchOrderVoucherData(voucherId, redeem === undefined ? showRedeem : redeem, ' ');

    BindOrders(startDate, endDate, redeem === undefined ? showRedeem : redeem, voucherId);
  };
  const handleVoucherPaymentsByIdforthirdParty = (voucherId, redeem, gid, pid) => {
    let item = voucherList.map((f) => { if (f.id === voucherId) { return (f.name); } });
    onOrdersVoucher();
    setVoucherId(voucherId);
    setDropDown(item);
    setShowCreateVoucherButton(false);
    if (redeem !== undefined && redeem !== 'All') {
      setShowRedeem(redeem);
    }
    BindOrders(startDate, endDate, redeem === undefined ? showRedeem : redeem, voucherId);

    //LoadSearchOrderVoucherDataForThridParty(voucherId, redeem === undefined ? showRedeem : redeem, 'B', gid, pid);
  };
  const onstartDateChnage = (date) => {
    setStartDate(date);
  };

  const handleSearchfilter = (search) => {
    if (search.length > 0) {
      LoadSearchOrderVoucherData(voucherId, showRedeem, search);
    } else {
      BindOrders(startDate, endDate, showRedeem, voucherId);
    }
  }
  const handleApproval = (id, invitation_id) => {
    let body = ([{
      groupId: getGroupID(), propertyId: propertyId,
      voucherId: id, status: 'Approve'
    }]);
    AxiosAPI({
      url: `${putAPI_approve_voucher}`,
      method: 'put',
      data: { 'VoucherList': body }
    }).then((res) => {
      if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
        && res.data.Messages !== null && res.data.Messages.length > 0) {
        setMsg(res.data.Messages);
        setOpen(true);
      }
      else { LoadData() }
    })
      .catch((err) => null);
    LoadData();
  };

  const handleReject = (id, invitation_id, status, fee) => {
    let body = ([{
      groupId: getGroupID(), propertyId: propertyId,
      voucherId: id, status: status, invitationId: invitation_id, processingFee: fee
    }]);
    AxiosAPI({
      url: `${putAPI_approve_voucher}`,
      method: 'put',
      data: { 'voucherList': body }
    }).then((data) => LoadData())
      .catch((err) => null);

  };
  const onEndDateChnage = (date) => {
    setEndDate(date);
  };

  function BindOrders(startdate, enddate, redeem, voucherId) {
    setOrderList([]);
    let fromDate = startdate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = enddate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    let temp = [];
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/voucher?redeem=${redeem}&voucherId=${voucherId}&fromDate=${fromDate}&toDate=${toDate}&groupId=${temp.length > 0 ? temp[0].groupId : getGroupID()}&propertyId=${temp.length > 0 ? temp[0].propertyId : propertyId}`,
    })
      .then(res => {
        setOrderList(res.data);
      })
      .catch(err => null);
  }

  const handleConnectedVoucher = (id, groups, property, senderGroup, senderProperty, type) => {
    setShowConnectedVoucher({
      groups: groups, property: property, id: id, isShow: true, senderGroupId: senderGroup,
      senderPropertyId: senderProperty, invitationtype: type
    });
  };

  const LoadSearchOrderVoucherData = (voucherId, redeem, search) => {
    setOrderList([]);
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Orders_Voucher}/search/voucher?redeem=${redeem}&voucherId=${voucherId}&search=${search}&groupId=${getGroupID()}&propertyId=${propertyId}`,
    })
      .then(res => {

        setOrderList(res.data);
        setLoading(false);
      })
      .catch(err => null);
  }

  const handleRedeemVoucher = (number, status) => {
    if (number !== undefined || null) {
      let date = moment();
      let redeemdate = date.format('YYYY-MM-DD HH:mm:ss');

      AxiosAPI({
        method: 'PUT',
        url: `${gAPI_Orders_Voucher}/voucher/redeem?id=00000000-0000-0000-0000-000000000000&status=2&voucherNumber=${number}&status=${status}&redeemDate=${redeemdate}`,
      })
        .then(res => {

          if (res.data.redeem) {
            BindOrders(startDate, endDate, showRedeem, voucherId);
          }
        })
        .catch(err => null);
    }
  };

  const handleBack = () => {
    LoadData();
    setShowListType('orderVouchers');
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex) => {
    if (toIndex < 0) return;
    const result = Array.from(voucherList);
    const [removed] = result.splice(fromIndex, 1);
    result.splice(toIndex, 0, removed);
    setVoucherList(result);
    var data = [];
    result.map((item, i) => {
      data.push({
        id: item.id,
        order: i
      })
    });
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Vouchers_Order}`,
      data: { data: data },
    }).then((res) => {
    }).catch((err) => {
      console.log('err', err);
    });
  };
  
  return (
    <Fragment>
      <CardHeader style={{ marginLeft: '-1.25rem', marginRight: '-1.25rem' }}>
        <Nav tabs className="card-header-tabs ml-0 mr-0">
          <NavItem className=" text-center" style={{ width: 'auto', background: '' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "vouchers",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("vouchers");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "vouchers" ? '#EF4A81' : 'black'}` }}>Vouchers</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "promoCodes",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("promoCodes");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "promoCodes" ? '#EF4A81' : 'black'}` }}>Promo Codes</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "gallery",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("gallery");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "gallery" ? '#EF4A81' : 'black'}` }}>Gallery</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "iconGallery",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("iconGallery");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "iconGallery" ? '#EF4A81' : 'black'}` }}>Icon Gallery</span>
            </NavLink>
          </NavItem>
          <NavItem className=" text-center" style={{ width: 'auto' }}>
            <NavLink
              style={{ background: 'none', cursor: 'pointer' }}
              className={classnames({
                active: activeTab === "invitations",
                "nav-link": true
              })}
              onClick={() => {
                setActiveTab("invitations");
              }}
              to="#"
            >
              <span style={{ color: `${activeTab === "invitations" ? '#EF4A81' : 'black'}` }}>Invitations</span>
            </NavLink>
          </NavItem>
        </Nav>
      </CardHeader>
      <TabContent activeTab={activeTab} className="">
        <TabPane tabId="vouchers" className="chat-app-tab-pane">
          <Card className="mb-4">
            <CardBody>
              <Row className="survey-app">
                <Colxx xxs="12">
                  <div className="mb-2">
                    {loading !== undefined && !loading && showCreateVoucherButton && <CreateVoucherForm voucherId={voucherId}
                      propertyId={propertyId}
                      userData={userData}
                      memberShipTags={memberShipTags}
                      ShowInviteVoucher={ShowInviteVoucher}
                      amadeus={amadeus}
                      mews={mewsIntegration}
                      reportingTagData={reportingTagData}
                      isCustomCode={showListType === 'codes' ? true : false}
                      inviteVoucher={inviteVoucher}
                      propertydata={propertydata}
                      handlePreviewVoucher={handlePreviewVoucher}
                      voucherName={voucherName}
                      websiteIntregation={websiteIntregation}
                      handleBuyOptionSetings={handleBuyOptionSetings}
                      locale={locale}
                      xolaIntegration={xolaIntegration}
                      handleConnectedVoucher={handleConnectedVoucher}
                      invitation={invitation}
                      voucherList={voucherList}
                      isBuyOption={showListType === 'optionsList' ? true : false}
                      LoadData={LoadData} />}
                  </div>
                </Colxx>

              </Row>
              {
                showListType === 'voucherList' ?
                  <Fragment>
                    <Row>
                      <Colxx xxs="4">
                        <div className="mb-2">
                          <div className="d-block d-md-inline-block">
                            <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                              <DropdownToggle caret color="outline-dark" size="xs">
                                Status
                                {" "}{SelectedStatus.label}
                              </DropdownToggle>
                              <DropdownMenu>
                                {statusOptions.map((order, index) => {
                                  return (
                                    <DropdownItem
                                      key={index}
                                      onClick={() => changeStatus(order.column)}
                                    >
                                      {order.label}
                                    </DropdownItem>
                                  );
                                })}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                            <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                              <input
                                type="text"
                                name="keyword"
                                id="search"
                                placeholder="Search"
                                onKeyPress={(e) => onSearchKey(e)}
                              />
                            </div>
                          </div>
                        </div>
                      </Colxx>
                      <Colxx xxs="8">
                        <div className="float-md-right">
                          <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                          <UncontrolledDropdown className="d-inline-block">
                            <DropdownToggle caret color="outline-dark" size="xs">
                              {SelectedPageSize}
                            </DropdownToggle>
                            <DropdownMenu right>
                              {pageSizes.map((size, index) => {
                                return (
                                  <DropdownItem
                                    key={index}
                                    onClick={() => changePageSize(size)}
                                  >
                                    {size}
                                  </DropdownItem>
                                );
                              })}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      </Colxx>
                    </Row>
                    <Separator className="mb-5" />
                  </Fragment> : ""
              }

              {
                showListType === 'optionsList' && (<Colxx xxs="10" md="2" className="">
                  <a onClick={() => { handleBackClick(); }}>
                    <h1 class="iconsminds-back"></h1></a>
                </Colxx>)
              }
              {showListType === 'voucherList' && !showConnectedVoucher.isShow && (<Fragment>
                {loading !== undefined && !loading ? (voucherList !== undefined && voucherList.length > 0 ?
                  <ReactDragListView

                    nodeSelector=".ant-list.draggable"
                    lineClassName="dragLine"
                    onDragEnd={(fromIndex, toIndex) => {
                      onDragEnd(fromIndex, toIndex);
                    }}>
                    {voucherList.map((item, index) => {
                      item.sellingOptions = item.buyOptions
                      return (
                        <List key={index} className="draggable">
                          <span className="draggable" style={{
                            position: 'absolute',
                          }}><a href="#"><i className="simple-icon-menu"></i></a></span>
                          <VoucherListItem
                            key={`guest_item_${index}`}
                            item={item}
                            memberShipTags={memberShipTags}
                            handleGenerateCode={(e) => setShowListType('codes')}
                            handleApproval={handleApproval}
                            toggleModal={toggleModal}
                            reportingTagData={reportingTagData}
                            LoadData={LoadData} handleVoucherName={handleVoucherName}
                            handleReject={handleReject}
                            handleVoucherPaymentsByIdforthirdParty={handleVoucherPaymentsByIdforthirdParty}
                            isBuyOption={showListType === 'optionsList' ? true : false}
                            propertyId={propertyId}
                            ShowInviteVoucher={ShowInviteVoucher}
                            inviteVoucher={inviteVoucher}
                            invitation={invitation}
                            websiteIntregation={websiteIntregation}
                            voucherList={voucherList}
                            propertydata={propertydata}
                            amadeus={amadeus}
                            mews={mewsIntegration}
                            xolaIntegration={xolaIntegration}
                            isHostedPageIntegration={isHostedPageIntegration}
                            extractData={extractData}
                            currency={currency}
                            handleVoucherFilter={handleVoucherFilter}
                            handleBuyOptionSetings={handleBuyOptionSetings}
                            handleVoucherPaymentsById={handleVoucherPaymentsById}
                          />
                        </List>
                      );
                    })}
                  </ReactDragListView>
                  : <div className="d-flex justify-content-center col-md-12"> <img className='non-item-voucher' src={no_vouchers} alt=""></img></div>
                ) : (
                  <div className="mx-auto my-auto">
                    <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                  </div>
                )
                }

              </Fragment>)
              }
              <Row className="col-md-12">
                {showListType === 'optionsList' &&
                  <Fragment>
                    {!buyOptionLoading && buyOption.filter(f => voucherName !== f.option).length > 0 &&
                       buyOption.filter(f => voucherName !== f.option).map((item, index) =>                       
                        <BuyOptionList
                          key={`guest_item_${index}`}
                          item={item}
                          toggleModal={toggleModal}
                          LoadData={LoadData}
                          amadeus={amadeus}
                          mews={mewsIntegration}
                          propertyId={propertyId}
                          voucherName={voucherName}
                          xolaIntegration={xolaIntegration}
                          isBuyOption={showListType === 'optionsList' ? true : false}
                          currency={currency}
                          extractData={extractData}
                          voucherId={voucherId}
                        />
                    
                    )}
                    {buyOptionLoading && <div className="mx-auto my-auto">
                      <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
                    </div>}
                  </Fragment>}

              </Row>
              <Row className="col-md-12">
                {showListType === 'orderVouchers' ?
                  <PurchasedVoucher
                    loading={loading}
                    onstartDateChange={onstartDateChnage}
                    onEndDateChange={onEndDateChnage}
                    handleSubmit={handleOrdersVoucherSubmit}
                    orderList={orderList}
                    handleBack={handleBack}
                    handleSearchfilter={handleSearchfilter}
                    handleVoucherPaymentsById={handleVoucherPaymentsById}
                    handleVoucherPaymentsByIdforthirdParty={handleVoucherPaymentsByIdforthirdParty}
                    voucherList={voucherList}
                    handleDropDown={handleDropDown}
                    handleRedeemVoucher={handleRedeemVoucher}
                    dropDown={dropDown}
                    voucherFilter={voucherFilter}
                    handleVoucherFilter={handleVoucherFilter}
                    showRedeem={showRedeem}
                    voucherId={voucherId}
                    locale={locale}
                    propertydata={propertydata}
                    handleCreateVoucherButtonShow={handleCreateVoucherButtonShow}
                  />
                  : (
                    <div className="" />
                  )}
              </Row>
              <Row>
                {showListType === 'voucherList' && <Pagination
                  currentPage={currentPage}
                  totalPage={TotalPages}
                  onChangePage={(i) => onChangePage(i)}
                />
                }
              </Row>

              {
                showOrderData ? <Fragment>
                  <ViewOrders
                    isopen={showOrderData}
                    toggle={() => { setShowOrderData(false) }}
                    orderData={orderdataById}
                    subOrderList={orderListByNumber}
                  />
                </Fragment> : ""
              }
              <Row className="col-md-12">
                {showListType === 'codes' ?
                  <CodeList
                    loading={loading}
                    onstartDateChange={onstartDateChnage}
                    onEndDateChange={onEndDateChnage}
                    handleSubmit={handleOrdersVoucherSubmit}
                    orderList={orderList}
                    handleBack={handleBack}
                    voucherList={voucherList}
                    handleDropDown={handleDropDown}
                    handleRedeemVoucher={handleRedeemVoucher}
                    showRedeem={showRedeem}
                    voucherId={voucherId}
                    voucherName={voucherName}
                    locale={locale}
                    propertydata={propertydata}
                    handleCodeList={(e) => setShowListType(e)}
                  />
                  : (
                    <div className="" />
                  )}
              </Row>
              {
                invitation.length > 0 && invitation.map((i) => {
                  if (i.status === 'Active' && i.type === 'Invite') {
                    return (<AcceptInvitation isVisible={showInvitation} propertyId={propertyId}
                      propertydata={propertydata} invitation={i} LoadData={LoadData} handleConnectedVoucher={handleConnectedVoucher}
                      toggle={() => SetShowinvitation(!showInvitation)} />);
                  }
                  else if (i.status === 'Active' && i.type === 'Sell') {
                    return <ApproveInvitation isVisible={showInvitation} propertyId={propertyId}
                      propertydata={propertydata} invitation={i} LoadData={LoadData} handleConnectedVoucher={handleConnectedVoucher}
                      toggle={() => SetShowinvitation(!showInvitation)} />
                  }
                })
              }
              {
                showInvitations && <ShowInvitations propertyId={propertyId} voucherList={voucherList}
                  handleConnectedVoucher={handleConnectedVoucher} hideModal={() => setShowInvitations(!showInvitations)} invitations={invitation} showModal={showInvitations}></ShowInvitations>
              }

              <Modal isOpen={showPreviewModal && voucherList.length === 0} toggle={() => handlePreviewVoucher(false)}>
                <ModalHeader toggle={() => handlePreviewVoucher(false)}>
                  Preview Voucher
                </ModalHeader>
                <ModalBody>
                  <div className='text-center'>


                    <p className="my-2 mx-1">Please create a voucher first to start seeing how it will look on your website</p>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button onClick={() => handlePreviewVoucher(false)}>
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
              <PreviewVoucherList></PreviewVoucherList>
            </CardBody>
          </Card>
        </TabPane>
        <TabPane tabId="promoCodes" className="chat-app-tab-pane">
           {activeTab === "promoCodes" && <PromoCodes propertyVouchers={propertyVouchers} propertydata={propertydata} propertyId={propertyId}></PromoCodes>}
        </TabPane>
        <TabPane tabId="invitations" className="chat-app-tab-pane">
        {activeTab === "invitations" && <Invitations></Invitations>}
        </TabPane>
        <TabPane tabId="gallery" className="chat-app-tab-pane" style={{background :"none"}}>
        {activeTab === "gallery" && <Gallery direct={true}></Gallery>}
        </TabPane>
        <TabPane tabId="iconGallery" className="chat-app-tab-pane" style={{background :"none"}}>
        {activeTab === "iconGallery" && <IconGallery direct={true}></IconGallery>}
        </TabPane>
      </TabContent>
      <Validation open={open} messages={msg} toggle={()=>{setOpen(!open)}}></Validation>
    </Fragment>

  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, currency } = settings;
  return {
    propertyId,
    locale,
    currency
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
